export default {
  // 通用
  common: 100,
  // 事项类型名称
  issueTypeName: 50,
  // 人员姓名
  memberName: 50,
  // 项目名称
  projectName: 100,
  // 组织名称
  orgName: 100,
  // 迭代名称
  sprintName: 100,
  // 迭代目标
  sprintTarget: 500,
  // 事项标题
  issueSummary: 300,
  // 字段说明
  fieldDesc: 300,
  // 字段名称
  fieldName: 50,
  // 工作流名称
  workflowName: 50,
  // 标签名称
  labelName: 50,
  // 项目描述
  projectDesc: 500,
  // 字段选型值
  fieldOption: 50,
  // 组件名称
  widgetName: 50,
  // 状态名称
  statusName: 50,
  // 仪表盘名称
  dashboardName: 50,
  // 智能助理场景名称
  smartAssistantName: 150,
  // webhook名称
  webhookName: 100,
  // 版本说明
  versionDesc: 500,
  // 成员分组名
  memberGroupName: 20,
  // 文本类型的字段长度
  textTypeField: 300,
  //保存筛选名长度
  saveFilterName: 50,
  // 项目模板名称长度
  projectTemplateName: 50,
  // 项目模板描述长度
  projectTemplateDesc: 500,
  // webIm意向输入长度
  aiRobotRecommendText: 1000,
  // 文档标题限制长度
  documentTitle: 300,
  // 富文本和多行文本默认值输入长度
  richDefaultText: 500,
  // openApi名称长度
  openApiName: 50,
  // openApi描述长度
  openApiDesc: 255,
  // 角色名称
  roleName: 20,
  // 版本名称长度
  releaseName: 100
};
